/*
官方文档：https://artskydj.github.io/jsPDF/docs/jsPDF.html#line
https://www.npmjs.com/package/jspdf
 */
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

export const downloadPDF = (page, filename) => {
    return new Promise((resolve, reject) => {
        html2canvas(page).then(function (canvas) {
            resolve(canvas2PDF(canvas, filename));
        })
    });
}
// 分页导出pdf
const canvas2PDFWithPage = (canvas, filename) => {
    let contentWidth = canvas.width;
    let contentHeight = canvas.height;

    // 一页pdf显示html页面生成的canvas高度；
    var pageHeight = contentWidth / 592.28 * 841.89
    // 未生成pdf的html页面高度
    var leftHeight = contentHeight;
    // pdf页面偏移
    var position = 0;
    // A4纸的尺[595.28,841.89],html页面生成的canvas在pdf中图片的宽高
    let imgWidth = 595.28;
    let imgHeight = 592.28 / contentWidth * contentHeight;
    var pageData = canvas.toDataURL("image/jpeg", 1.0)
    let pdf = new jsPDF("", "pt", "a4");
    // 有两个高度需要区分，一个是html页面的实际高度，和生成的pdf的页面高度(841.89)
    // 当内容未超过pdf一页显示的范围，无需分页
    if (leftHeight < pageHeight) {
        pdf.addImage(
            pageData,
            "JPEG",
            0,
            0,
            imgWidth,
            imgHeight
        );
    } else {
        while (leftHeight > 0) {
            pdf.addImage(
                pageData,
                "JPEG",
                0,
                position,
                imgWidth,
                imgHeight
            );
            leftHeight -= pageHeight
            position -= 841.89;
            // 避免添加空白页
            if (leftHeight > 0) {
                pdf.addPage();
            }
        }
    }
    pdf.save(filename + ".pdf");
}

// 不分页导出
const canvas2PDF = (canvas, filename) => {
    let contentWidth = canvas.width;
    let contentHeight = canvas.height;

    let imgWidth = contentWidth;
    let imgHeight = contentHeight;

    // 第一个参数：l：横向 p：纵向
    // 第二个参数：测量单位("pt","mm","cm","m","in" or "px")
    let pdf = new jsPDF("p", "pt", [imgWidth, imgHeight]);

    pdf.addImage(
        canvas.toDataURL("image/jpeg", 1.0),
        "JPEG",
        0,
        0,
        imgWidth,
        imgHeight
    );
    return pdf.save(filename + ".pdf");
}